import { Component, OnInit } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Element } from '../element';
import { Tag } from '../tag';
import { City } from '../city';

@Component({
    selector: 'dashboard',
    providers: [DashboardService],
    template: require('./dashboard.component.html'),
})

export class MainDashboardComponent implements OnInit {

    router: Router;

    selectedLanguage: string;
    elementsToShow: number;

    premiumsPage: number;
    premiumElements: Element[];
    showPremiums: boolean;

    elementsPage: number;
    elementsCount: number;
    listElements: Element[];

    selectedElement: Element;

    tagsToShowInElement: number;

    classLoginModal: any;
    loginEmail: string;
    loginPassword: string;
    loginCode: number;

    classMessageModal: any;
    messageTitle: string;
    messageContent: string;
    messageCode: number;

    userRole: string;
    userIsGuest: boolean;
    userIsSuperUser: boolean;
    userIsAdmin: boolean;

    categoryFilter: string;
    sellerFilter: string;
    citiesFilter: string;
    tagsFilter: string;
    searchFilter: string;

    scrollParam: string;
    scrollHeight: number;
    loadedPage: number;

    pageHeightLimit: number;
    loading: boolean;

    elementHover: number;

    loadingElements: boolean;

    constructor(private _dashboardService: DashboardService, _parentRouter: Router, private route: ActivatedRoute) {

        this.router = _parentRouter;
        this.elementsToShow = 10;
        this.elementsPage = 0;
        this.premiumsPage = 0;
        

        this.selectedElement = null;

        this.tagsToShowInElement = 5;

        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.loginEmail = "";
        this.loginPassword = "";
        this.loginCode = 0;

        this.classMessageModal = { 'model': true, 'show': false, 'hide': true };
        this.messageTitle = "";
        this.messageContent = "";
        this.messageCode = 0;

        this.userRole = "guest";
        this.setUserRole(this.userRole);

        this.pageHeightLimit = 200;
        this.loading = false;

        this.elementHover = -1;
        this.showPremiums = true;

    }

    ngOnInit() {
        
        this._dashboardService.getUserStatus().then(status => {
            this.userRole = status.role;
            this.setUserRole(this.userRole);
        });

        this.route.params.subscribe(params => {
            this.elementsPage = 0;
            this.categoryFilter = params['categoryType'];
            this.sellerFilter = params['sellerType'];
            this.citiesFilter = params['citiesFilter'];
            this.tagsFilter = params['tagsFilter'];
            this.searchFilter = params['searchFilter'];
            this.scrollParam = params['scroll'];
            this.scrollHeight = Number(params['scrollHeight']);
            this.loadedPage = Number(params['loadedPage']);                        
            this.ngOnInit2();
        });        

    }

    ngOnInit2() {        
        console.log(this.filtersAreAplicated());
        if (!this.filtersAreAplicated()) {            
            if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {                 
                this._dashboardService.getElementsUntilPage(this.loadedPage).subscribe(res => {                    
                    if (res != null) {
                        this.listElements = res;
                        for (var i = 0; i < this.listElements.length; i++) {
                            this.listElements[i].tags_index = 0;
                        }
                        this.elementsPage = this.loadedPage; 
                    }                    
                });
            } else {                
                this._dashboardService.getElementsByPage(this.elementsPage).subscribe(res => {                                        
                    if (res != null) {
                        this.listElements = res;
                        for (var i = 0; i < this.listElements.length; i++) {
                            this.listElements[i].tags_index = 0;
                        }                            
                    }                    
                });
            }

            this.showPremiums = true;
            this._dashboardService.getPremiumElementsByPage(this.premiumsPage).subscribe(res => {                
                if (res != null) {
                    this.premiumElements = res;
                }                
            });

            this._dashboardService.getElementsCount().subscribe(res => {                
                this.elementsCount = res;            
            });

        } else {
            
            if (!this.isNullOrEmpty(this.categoryFilter)) {                
                if (this.categoryFilter == "PRE") {

                    this.showPremiums = false;

                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                                this.elementsPage = this.loadedPage;
                            }                            
                        });
                    } else {
                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                            }                            
                        });
                    }

                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                        
                        this.elementsCount = res;                        
                    });

                } else if (this.categoryFilter == "PRO") {

                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                                this.elementsPage = this.loadedPage;
                            }                            
                        });
                    } else {
                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                            }                            
                        });
                    }

                    this.showPremiums = true;
                    this._dashboardService.getPremiumElementsByPageWithFilters(this.premiumsPage, this.sellerFilter, this.citiesFilter, this.tagsFilter).subscribe(res => {                        
                        if (res != null) {
                            this.premiumElements = res;
                        }                        
                    });

                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                        
                        this.elementsCount = res;                        
                    });                    

                } else if (this.categoryFilter == "TRA") {

                    this.showPremiums = false;

                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                                this.elementsPage = this.loadedPage;
                            }                            
                        });
                    } else {                        
                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                            
                            if (res != null) {
                                this.listElements = res;
                                for (var i = 0; i < this.listElements.length; i++) {
                                    this.listElements[i].tags_index = 0;
                                }
                            }                            
                        });
                    }

                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                        
                        this.elementsCount = res;                        
                    });                    

                }

            } else {                
                if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {                    
                    this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                        
                        if (res != null) {
                            this.listElements = res;
                            for (var i = 0; i < this.listElements.length; i++) {
                                this.listElements[i].tags_index = 0;
                            }
                        }
                        this.elementsPage = this.loadedPage;                        
                    });
                } else {
                    this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                                                
                        if (res != null) {
                            this.listElements = res;
                            for (var i = 0; i < this.listElements.length; i++) {
                                this.listElements[i].tags_index = 0;
                            }
                        }                        
                    });
                }

                this.showPremiums = true;
                this._dashboardService.getPremiumElementsByPageWithFilters(this.premiumsPage, this.sellerFilter, this.citiesFilter, this.tagsFilter).subscribe(res => {                    
                    if (res != null) {
                        this.premiumElements = res;
                    }                    
                });

                this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {                    
                    this.elementsCount = res;                    
                });

            }

        }

    }

    loadElements(page: number): any[] {
        if (this.loadedPage >= page) {            

            var res2 = this.loadElements(page + 1);


            this._dashboardService.getElementsByPage(page).subscribe(res => {
                for (var i = 0; i < res.length; i++) {
                    res[i].tags_index = 0;
                }
                res = res.concat(res2);
                return res;
            });



        } else {            
            return [];
        }
    }

    setScroll() {

        if (!this.isNullOrEmpty(this.scrollParam) && document.body.scrollHeight >= this.scrollHeight) {
            document.body.scrollTop = Number(this.scrollParam);
            this.scrollParam = null;
        }
    }

    filtersAreAplicated(): boolean {

        if ((this.categoryFilter == null || this.categoryFilter == undefined || this.categoryFilter == "" || this.categoryFilter == "null") &&
            (this.sellerFilter == null || this.sellerFilter == undefined || this.sellerFilter == "" || this.sellerFilter == "null") &&
            (this.citiesFilter == null || this.citiesFilter == undefined || this.citiesFilter == "" || this.citiesFilter == "null") &&
            (this.tagsFilter == null || this.tagsFilter == undefined || this.tagsFilter == "" || this.tagsFilter == "null") &&
            (this.searchFilter == null || this.searchFilter == undefined || this.searchFilter == "" || this.searchFilter == "null")) {

            return false;

        } else {

            return true;
        }

    }

    isNullOrEmpty(text: string): boolean {
        if (text == null || text == undefined || text == "" || text == "null") {
            return true;
        } else {
            return false;
        }
    }

    previousTagsClicked(element: Element) {
        element.tags_index--;
    }

    nextTagsClicked(element: Element) {
        element.tags_index++;
    }

    loginClicked() {

        this._dashboardService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {
                localStorage.setItem('userName', result.user.name);
                location.reload();
            }
        });

    }

    sendMessageClicked() {

        var titleIntroduced: boolean;
        if (this.messageTitle == null || this.messageTitle == undefined || this.messageTitle == "") {
            titleIntroduced = false;
        } else {
            titleIntroduced = true;
        }

        var contentIntroduced: boolean;
        if (this.messageContent == null || this.messageContent == undefined || this.messageContent == "") {
            contentIntroduced = false;
        } else {
            contentIntroduced = true;
        }

        if (!titleIntroduced && contentIntroduced) {
            this.messageCode = 1;
        } else if (titleIntroduced && !contentIntroduced) {
            this.messageCode = 2;
        } else if (!titleIntroduced && !contentIntroduced) {
            this.messageCode = 3;
        } else {
            this._dashboardService.sendMessage(this.messageTitle, this.messageContent, this.selectedElement.user_id).then(res => {
                if (res.code == 1) {
                    this.closeMessageModal();
                }
            });
        }

    }

    elementFavoriteClicked(element: Element) {

        if (this.userRole == "guest") {

            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;

        } else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
            this._dashboardService.manageFavorite(element.id).then(result => {
                if (result.code == 1) {
                    if (result.type == "insert") {
                        element.favorite = true;
                    } else {
                        element.favorite = false;
                    }
                }
            });
        }

    }

    elementMessageClicked(element: Element) {
        if (this.userRole == "guest") {

            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;

        } else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
            this.selectedElement = element;
            this.classMessageModal.show = true;
            this.classMessageModal.hide = false;
        }
    }

    registerClicked() {

        this.router.navigate(['/register']);

    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    closeMessageModal() {
        this.messageCode = 0;
        this.classMessageModal.show = false;
        this.classMessageModal.hide = true;
    }

    setUserRole(userRole: string) {

        if (userRole == "guest") {
            this.userIsGuest = true;
            this.userIsSuperUser = false;
            this.userIsAdmin = false;
        } else if (userRole == "superuser") {
            this.userIsGuest = false;
            this.userIsSuperUser = true;
            this.userIsAdmin = false;
        } else if (userRole == "admin") {
            this.userIsGuest = false;
            this.userIsSuperUser = false;
            this.userIsAdmin = true;
        }

    }

    getFavoriteColor(element: Element) {
        if (element.favorite) {
            return "green";
        } else {
            return "#6fb3cb";
        }
    }

    elementClicked(element: Element) {

        if (!this.filtersAreAplicated()) {
            var category: string = null;
            var seller: string = null;
            var cities: string = null;
            var tags: string = null;
        } else {
            var category: string = this.categoryFilter;
            var seller: string = this.sellerFilter;
            var cities: string = this.citiesFilter;
            var tags: string = this.tagsFilter;
        }

        this.router.navigate(['/main', 'elementdetail', { categoryType: category, sellerType: seller, citiesFilter: cities, tagsFilter: tags, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: this.elementsPage }]);
    }

    previousElements() {
        this.elementsPage--;

        if (!this.filtersAreAplicated()) {
            this._dashboardService.getElementsByPage(this.elementsPage).subscribe(res => {
                if (res != null) {
                    this.listElements = res;
                    for (var i = 0; i < this.listElements.length; i++) {
                        this.listElements[i].tags_index = 0;
                    }
                }
            });
        }
    }

    nextElements() {
        this.elementsPage++;

        if (!this.filtersAreAplicated()) {
            this._dashboardService.getElementsByPage(this.elementsPage).subscribe(res => {
                if (res != null) {
                    this.listElements = res;
                    for (var i = 0; i < this.listElements.length; i++) {
                        this.listElements[i].tags_index = 0;
                    }
                }
            });
        }
    }

    onScroll(event: any) {     
        if (window.pageYOffset >= document.body.scrollHeight - window.innerHeight - this.pageHeightLimit && !this.loading) {
            if (this.elementsCount > this.listElements.length) {
                this.loading = true;
                this.elementsPage++;

                if (!this.filtersAreAplicated()) {
                    this._dashboardService.getElementsByPage(this.elementsPage).subscribe(res => {
                        if (res != null) {
                            this.listElements = this.listElements.concat(res);
                            for (var i = this.elementsPage * this.elementsToShow; i < this.listElements.length; i++) {
                                this.listElements[i].tags_index = 0;
                            }
                        }
                        this.loading = false;
                    });
                } else {
                    this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(res => {
                        if (res != null) {
                            this.listElements = this.listElements.concat(res);
                            for (var i = this.elementsPage * this.elementsToShow; i < this.listElements.length; i++) {
                                this.listElements[i].tags_index = 0;
                            }
                        }
                        this.loading = false;
                    });
                }
            }
        }
    }

    mouseOverElement(element_id: number) {
        this.elementHover = element_id;
    }

    mouseLeaveElement() {
        this.elementHover = -1;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/dashboard/dashboard.component.ts
 **/